import DesktopPortfolio from "./DesktopPortfolio";

function App() {
  return <DesktopPortfolio />;
}

export default App;
